import type { InjectionKey } from 'vue'

export const GlobalStore = Symbol('GlobalStore') as InjectionKey<Record<string, boolean>>
